import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  LOAD_LIST_PATIENT_KIN,
  LOAD_LIST_PATIENT_KIN_ERROR,
  LOAD_LIST_PATIENT_KIN_SUCCESS,
  RESET_LIST_PATIENT_KIN,
} from '../type';
import { initialState } from './initialize';

const patientKinReducer = handleActions(
  new Map([
    [
      LOAD_LIST_PATIENT_KIN,
      state => {
        return update(state, {
          patientKin: {
            error: { $set: '' },
            loading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_LIST_PATIENT_KIN_ERROR,
      (state, action) => {
        return update(state, {
          patientKin: {
            loading: { $set: false },
            error: { $set: action.payload },
          },
        });
      },
    ],
    [
      LOAD_LIST_PATIENT_KIN_SUCCESS,
      (state, action) => {
        return update(state, {
          patientKin: {
            loading: { $set: false },
            data: { $set: action.payload },
          },
        });
      },
    ],
    [
      RESET_LIST_PATIENT_KIN,
      (state, action) => {
        return update(state, {
          patientKin: {
            loading: { $set: false },
            data: { $set: null },
          },
        });
      },
    ],
  ]),
  initialState,
);

export default patientKinReducer;
